import { render, staticRenderFns } from "./SampleDocument.vue?vue&type=template&id=54f33dc2&"
import script from "./SampleDocument.vue?vue&type=script&lang=js&"
export * from "./SampleDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports